import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/EngineGlassmorphism.css';

export default function DashboardLaunchpad({ user }) {
  const navigate = useNavigate();

  const toolCategories = [
    {
      title: "🎯 Growth & Niche Opportunity Suite (Phase 2)",
      description: "High-value differentiation tools for market positioning.",
      color: "linear-gradient(135deg, #a855f7, #6366f1)",
      badge: "Phase 2 Suite",
      items: [
        { name: "Niche Finder (NOI)", cost: "20 Credits", desc: "Niche Opportunity Index search & competition gap.", path: "/niche-research" },
        { name: "Upload Schedule Heatmap", cost: "15 Credits", desc: "24x7 audience active heatmaps & optimal publish slots.", path: "/upload-optimizer" },
        { name: "Tag Gap Comparison", cost: "15 Credits", desc: "Competitor tag overlap & missing tag list.", path: "/tag-gap" },
        { name: "Revenue & CPM Estimator", cost: "10 Credits", desc: "Category CPM rates & monthly AdSense projections.", path: "/revenue-estimator" }
      ]
    },
    {
      title: "✨ AI Audit & Diagnostics Suite",
      description: "Complete YouTube video & channel optimization engine.",
      color: "linear-gradient(135deg, #8b5cf6, #ec4899)",
      badge: "Core Suite",
      items: [
        { name: "Single Video Audit", cost: "5 Credits", desc: "SEO, engagement & quality score analysis.", path: "/video-audit" },
        { name: "Channel Health Audit", cost: "25 Credits", desc: "Aggregate 10-video composite score & strategy.", path: "/video-audit" },
        { name: "Bulk Video Audit Matrix", cost: "40 Credits", desc: "Side-by-side comparative table for up to 10 videos.", path: "/video-audit" }
      ]
    },
    {
      title: "💬 Audience Intelligence Suite",
      description: "Extract real viewer sentiment, questions, and demand.",
      color: "linear-gradient(135deg, #ec4899, #3b82f6)",
      badge: "Audience AI",
      items: [
        { name: "Real Comment Mining", cost: "10 Credits", desc: "Live NLP question extraction & sentiment %.", path: "/comment-mining" },
        { name: "SEO Keyword Strategy", cost: "20 Credits", desc: "Search volume, content gaps & missing subtopics.", path: "/keyword-analysis" }
      ]
    },
    {
      title: "🏆 Competitor & Market Research",
      description: "Outrank top niche creators and spot viral momentum.",
      color: "linear-gradient(135deg, #f59e0b, #ec4899)",
      badge: "Market Intel",
      items: [
        { name: "Competitor Intelligence", cost: "30 Credits", desc: "Channel-to-channel metric comparison.", path: "/pages/competitor" },
        { name: "Trending Topics Scan", cost: "15 Credits", desc: "Category velocity trends & viral spikes.", path: "/pages/trending" }
      ]
    },
    {
      title: "✍️ Studio & Historical Analytics",
      description: "Create AI scripts and track performance over time.",
      color: "linear-gradient(135deg, #10b981, #3b82f6)",
      badge: "Studio",
      items: [
        { name: "AI Script Writer", cost: "15 Credits", desc: "Hook, retention body & CTA script generator.", path: "/script-generator" },
        { name: "Audit History & Trends", cost: "0 Credits", desc: "Time-series score progression line graphs.", path: "/history" }
      ]
    }
  ];

  return (
    <div className="engine-dashboard" style={{ padding: '1rem 0' }}>
      {/* Banner */}
      <header className="engine-header" style={{ marginBottom: '2rem', textAlign: 'center' }}>
        <h1 style={{ fontSize: '2.2rem', fontWeight: 800, background: 'linear-gradient(90deg, #8b5cf6, #ec4899, #3b82f6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', margin: 0 }}>
          🚀 ContentSERP Creator Launchpad
        </h1>
        <p style={{ color: '#94a3b8', fontSize: '1rem', marginTop: '0.5rem', maxWidth: '650px', margin: '0.5rem auto 0 auto' }}>
          Select any tool below to launch optimizations, audience intelligence, competitor analysis, or script generation.
        </p>
      </header>

      {/* Grid of Tool Suites */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '1.5rem' }}>
        {toolCategories.map((cat, idx) => (
          <div key={idx} className="engine-glass-panel" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', border: '1px solid rgba(255,255,255,0.08)' }}>
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.8rem' }}>
                <h3 style={{ margin: 0, fontSize: '1.2rem', color: '#f8fafc' }}>{cat.title}</h3>
                <span style={{ background: 'rgba(139,92,246,0.2)', color: '#c084fc', padding: '0.2rem 0.6rem', borderRadius: '6px', fontSize: '0.75rem', fontWeight: 700 }}>
                  {cat.badge}
                </span>
              </div>
              <p style={{ color: '#94a3b8', fontSize: '0.85rem', marginBottom: '1.2rem' }}>{cat.description}</p>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
                {cat.items.map((tool, tIdx) => (
                  <div 
                    key={tIdx} 
                    onClick={() => navigate(tool.path)}
                    style={{
                      background: 'rgba(0,0,0,0.3)',
                      padding: '0.9rem',
                      borderRadius: '10px',
                      cursor: 'pointer',
                      border: '1px solid rgba(255,255,255,0.05)',
                      transition: 'all 0.2s ease-in-out'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.borderColor = '#8b5cf6'}
                    onMouseLeave={(e) => e.currentTarget.style.borderColor = 'rgba(255,255,255,0.05)'}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <strong style={{ color: '#e2e8f0', fontSize: '0.95rem' }}>{tool.name}</strong>
                      <span style={{ background: 'rgba(236,72,153,0.15)', color: '#f472b6', padding: '0.15rem 0.5rem', borderRadius: '6px', fontSize: '0.75rem', fontWeight: 600 }}>
                        {tool.cost}
                      </span>
                    </div>
                    <p style={{ margin: '0.3rem 0 0 0', color: '#94a3b8', fontSize: '0.8rem' }}>{tool.desc}</p>
                  </div>
                ))}
              </div>
            </div>

            <button 
              onClick={() => navigate(cat.items[0].path)}
              style={{
                marginTop: '1.5rem',
                width: '100%',
                padding: '0.7rem',
                background: cat.color,
                border: 'none',
                borderRadius: '8px',
                color: '#fff',
                fontWeight: 700,
                cursor: 'pointer'
              }}
            >
              Open Suite →
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
